import angular from 'angular';
import './resource';
import '../app.constants';
import './subscription';

const module = angular.module('whyline.resources.sla', [
  'whyline.constants',
  'whyline.resources.resource',
  'whyline.resources.subscription',
]);

const SlaFactory = (API_URL, $http, $timeout, Resource) => {
  /* @ngInject */
  const _type = 'sla?placeId';

  const _schema = {
    _id: {
      type: String,
    },
    organizationId: {
      type: String,
      required: true,
    },
    organizationSlaId: {
      type: String,
      required: true,
    },
    enabled: {
      required: true,
      type: String,
    },
  };

  const Sla = function (data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });

    this.enable = () => {
      const promise = $http.put(`${API_URL}${_type}/${this._id}/enable`);
      promise.then((response) => {
        const item = response.data;
        $timeout(() => {
          // Cuando halla respuesta, modificar el cache
          Sla.UpdateCache(item._id, item, null);
        });
        // Devuelve la respuesta desde el cache.
        return Sla.GetOneFromCache('_id', this._id);
      });
      return promise;
    };
  };

  Sla.GetSlaById = (slaId) => {
    const url = `${API_URL}sla/${slaId}/?placeId`;
    return $http.get(url).then((response) => Promise.resolve(response.data));
  };

  Sla.GetAll = () => {
    const url = `${API_URL}${_type}/${this._id}`;
    return $http.get(url).then((response) => Promise.resolve(response.data));
  };

  Sla.GetAllEnabled = (placeId) => {
    const url = `${API_URL}sla/enabled/${`?placeId=${placeId}` ?? '?placeId'}`;
    return $http.get(url).then((response) => Promise.resolve(response.data));
  };

  Sla.prototype = new Resource(_type, _schema, Sla);

  Resource.Extend(_type, Sla);

  //five minutes
  const validityTime = 5 * 60 * 1000;
  Sla.InitCache(validityTime);

  return Sla;
};

module.exports = module.factory('Sla', SlaFactory);
